import type { ErrorEvent } from '@sentry/angular';

// A frame is ours only when it is a .js file on the bundle origin. Page-URL frames share the
// origin but are not .js, which is exactly where injected inline scripts get attributed.
// document.baseURI, not location.origin: the bundles load relative to the absolute <base href>.
function isOwnBundleFrame(filename: string | undefined): boolean {
  try {
    const url = new URL(filename ?? '');
    return url.origin === new URL(document.baseURI).origin && url.pathname.endsWith('.js');
  } catch {
    return false;
  }
}

// Chrome iOS and the Google app inject a script that recurses into a stack overflow. Its frames
// are the page URL or missing, never our bundles, so a recursion in our own code is still reported.
export function isGoogleIosInjectedRecursion(event: ErrorEvent): boolean {
  const exceptions = event.exception?.values ?? [];
  if (!exceptions.some(exception => exception.value?.includes('Maximum call stack size exceeded'))) {
    return false;
  }
  const userAgent = event.request?.headers?.['User-Agent'] ?? globalThis.navigator?.userAgent ?? '';
  if (!/\b(CriOS|GSA)\//.test(userAgent)) {
    return false;
  }
  return !exceptions.some(exception =>
    (exception.stacktrace?.frames ?? []).some(frame => isOwnBundleFrame(frame.filename))
  );
}
